/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Tc_OffsetInputs */



/**
* | output |
* | --- |
* | "TC Offset" |
*
* @param {Subtitle_Export_Tc_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_tc_offset = /** @type {((inputs?: Subtitle_Export_Tc_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Tc_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Décalage TC")
	if (locale === "de") return /** @type {LocalizedString} */ ("TC Offset")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offset TC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смещение TC")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazamiento de TC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("TC偏移")
	if (locale === "ja") return /** @type {LocalizedString} */ ("TCオフセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीसी ऑफसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslocamento TC")
	return /** @type {LocalizedString} */ ("TC Offset")
});